module.exports = __webpack_public_path__ + "img/375.51df918f.jpg";